export const ESessionStorageKey = {
  // auth
  AuthRequestState: "authRequestState",
  AuthRequestContext: "authRequestContext",
  AuthFromLocation: "authFromLocation",
} as const;

export type ESessionStorageKey =
  typeof ESessionStorageKey[keyof typeof ESessionStorageKey];
